import { motion } from "framer-motion";
import { ArrowUpRight, BadgeCheck, MessageSquare, Zap } from "lucide-react";

const principles = [
  [BadgeCheck, "Founder-led builds"],
  [MessageSquare, "Direct communication"],
  [Zap, "2026 performance standards"],
];

export default function FounderSection({ openBooking }) {
  return (
    <section id="founder" data-testid="founder-section" className="section-shell pb-24 sm:pb-32">
      <div className="grid gap-10 rounded-[2rem] border border-white/10 bg-[#0F0F17]/75 p-6 shadow-2xl shadow-black/25 sm:p-10 lg:grid-cols-[0.78fr_1.22fr] lg:items-center lg:p-12">
        <motion.div
          data-testid="founder-photo-frame"
          initial={{ opacity: 0, x: -36 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative mx-auto w-full max-w-sm"
        >
          <div className="absolute -inset-4 rounded-[2rem] bg-cyan-300/10 blur-2xl" aria-hidden="true" />
          <img
            src="/tyler-founder.jpg"
            alt="Tyler, founder of Tybra Digital"
            data-testid="founder-photo"
            loading="lazy"
            className="relative aspect-square w-full rounded-[1.7rem] border border-cyan-300/25 object-cover grayscale shadow-[0_0_70px_rgba(0,240,255,0.12)]"
            style={{ clipPath: "polygon(0 0, 100% 4%, 96% 100%, 4% 96%)" }}
          />
          <span className="absolute bottom-5 left-5 rounded-full bg-black/65 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-200 backdrop-blur-md">Founder / Tyler</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p data-testid="founder-eyebrow" className="eyebrow">Founder / direct line</p>
          <h2 data-testid="founder-heading" className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-[-0.05em] text-white sm:text-6xl">Built personally by Tyler.</h2>
          <p data-testid="founder-description" className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            Tybra Digital is intentionally founder-led. Tyler shapes the strategy, design, and technical direction behind each project, so your website is treated like a business asset—not passed through a template queue.
          </p>
          <div data-testid="founder-principles" className="mt-8 flex flex-wrap gap-3">
            {principles.map(([Icon, label]) => (
              <span key={label} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300">
                <Icon className="h-4 w-4 text-cyan-300" />{label}
              </span>
            ))}
          </div>
          <button data-testid="founder-book-button" onClick={() => openBooking("New website")} className="cyan-button mt-10 rounded-full px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.22em]">
            Book with Tyler <ArrowUpRight className="h-4 w-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
